<template>
  <div class="float-right">
    <b-modal
        :ref="name"
        :title="`${$t('administrator.labels.security_check') } ${administratorDetails.email}`"
        ok-title="Ok"
        ok-only
        size="xl">
      <div class="create-question">
        <div>
          <div class="row">
            <div class="col-12">
              <div class="d-flex">
                <b-form-group
                    label-for="group-key"
                    class="mr-1">
                  <b-form-input id="group-nam1e" :placeholder="$t('administrator.edit-role.find-group')"
                                v-model="filterGroupsPhrase" trim></b-form-input>
                </b-form-group>
                <b-form-group
                    label-for="group-key"
                    class="mr-1">
                  <b-form-input id="group-nam1e" :placeholder="$t('administrator.edit-role.find-role')"
                                v-model="filterRolesPhrase" trim></b-form-input>
                </b-form-group>
                <select v-model="filterCategorySelect" class="form-control">
                  <option>{{ $t("administrator.roles-filter.all-role-filter") }}</option>
                  <option>{{ $t('administrator.roles-filter.no-category-role-filter') }}</option>
                  <option :value="category" v-for="category in roleCategories" :key="category">{{ category }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <b-card>
          <template #header>
            <div class="row">
              <div class="col-6">
                <p class="h5 text-bold pl-4">{{ $t('administrator.labels.assigned_groups') }}</p>
              </div>
              <div class="col-6">
                <p class="h5">{{ $t('administrator.labels.roles_in_group') }}</p>
              </div>
            </div>
          </template>
<!--          <b-card-body v-if="!filteredRolesInGroup">-->
<!--            <div>-->
<!--              <p class="h6 text-center">PPPP PPPP</p>-->
<!--            </div>-->

<!--          </b-card-body>-->
          <b-card-body v-if="filteredRolesInGroup">
            <div v-for="(group, groupIndex) in filteredGroups" :key="group.id" class="row mb-3">
              <ul class="list-group col-12">
                <li class="list-group-item d-flex">
                  <div class="col-6">
                    <p class="h4 mt-3">{{ group.name }}</p>
                  </div>
                  <div class="col-6">
                    <ul class="list-group">
                      <li v-for="(role,index) in filteredRolesInGroup[groupIndex]" :key="index" class="list-group-item">
                        <span class="text-bold text-success">{{ role.category ? role.category : '' }}</span> {{ role.role }}
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>

            </div>
          </b-card-body>
        </b-card>

        <b-card>
          <template #header>
            <div class="row">
              <div class="col-6">
                <p class="h5 text-bold"></p>
              </div>
              <div class="col-6">
                <p class="h5 text-bold">{{ $t('administrator.labels.assigned_roles') }}</p>
              </div>
            </div>
          </template>
          <b-card-body>
            <div class="row">
              <div class="col-6"></div>
              <div class="col-6">
                <ul v-if="administratorRoles" class="list-group">
                  <li v-for="role in filteredRoles" :key="role.role" class="list-group-item">
                    <span class="text-bold text-success">{{ role.category ? role.category : '' }}</span> {{ role.role }}
                  </li>
                </ul>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
//TODO: import / load / get locale the right way
let locale = locale ? locale : "en";

export default {
  data() {
    return {
      name: 'default-modal',
      title: 'default-title',
      filterCategorySelect: '',
      filterGroupsPhrase: '',
      filterRolesPhrase: '',
      roleCategories: [],
      allRolesFilterName: this.$t('administrator.roles-filter.all-role-filter'),
      noCategoryRoleFilterName: this.$t('administrator.roles-filter.no-category-role-filter')
    }
  },
  mounted: function () {
    this.$refs[this.name].show();

    if (this.administratorGroups) {
      this.$store.dispatch('administrator/getAdministratorDetailsGroupsWithRoles');
    }

    this.prepareCategoryList();
  },
  methods: {
    prepareCategoryList() {
      const categories = [];

      this.roles.forEach(role => {
        if (role.category) {
          categories.push(role.category);
        }
      });

      this.roleCategories = categories.filter((value, index) => categories.indexOf(value) === index);
    },
  },
  computed: {
    ...mapState({
      administratorDetails: state => state.administrator.administratorDetails,
      roles: state => state.administrator.roles,
      administratorRoles: state => state.administrator.administratorDetails.roles,
      administratorGroups: state => state.administrator.administratorDetails.groups,
      administratorDetailsGroupsWithRoles: state => state.administrator.administratorDetailsGroupsWithRoles
    }),
    filteredRolesInGroup() {
      const filterCategory = this.filterCategorySelect;
      const allRolesFilter = this.allRolesFilterName;
      const noCategoryFilter = this.noCategoryRoleFilterName;
      let filteredRolesInGroup = [];

      this.filteredGroups.forEach((group, index) => {
        filteredRolesInGroup.push([]);

        group.roles.forEach(roleFromGroup => {
          this.roles.forEach(role => {
            if (role.role === roleFromGroup.role && role.role.toLowerCase().match(this.filterRolesPhrase.toLowerCase())) {
              filteredRolesInGroup[index].push(role);
            }
          });
        })
      });

      if (this.filterCategorySelect !== '') {
        filteredRolesInGroup.forEach((roles, index) => {
          filteredRolesInGroup[index] = [];

          roles.forEach(ro => {
            if (ro.category && filterCategory !== allRolesFilter && filterCategory !== noCategoryFilter && ro.category.toLowerCase().match(this.filterCategorySelect.toLowerCase())) {
              filteredRolesInGroup[index].push(ro);
            } else if (filterCategory === allRolesFilter) {
              filteredRolesInGroup[index].push(ro);
            } else if (filterCategory === noCategoryFilter && !ro.category) {
              filteredRolesInGroup[index].push(ro);
            }
          });
        });
      }

      return filteredRolesInGroup;
    },
    filteredGroups() {
      let filteredGroups = [];

      if (this.administratorDetailsGroupsWithRoles) {
        filteredGroups = this.administratorDetailsGroupsWithRoles;

        if (filteredGroups.length > 0 && this.filterGroupsPhrase !== '') {
          filteredGroups = filteredGroups.filter(group => {
            return group.name.toLowerCase().match(this.filterGroupsPhrase.toLowerCase());
          });
        }
      }

      return filteredGroups;
    },
    filteredRoles() {
      const filterCategory = this.filterCategorySelect;
      const allRolesFilter = this.allRolesFilterName;
      const noCategoryFilter = this.noCategoryRoleFilterName;

      let rolesWithCategories = [];

      this.roles.forEach(role => {
        this.administratorRoles.forEach(adminRole => {
          if (adminRole === role.role) {
            rolesWithCategories.push(role);
          }
        })
      });

      if (rolesWithCategories.length > 0 && this.filterRolesPhrase !== '') {
        rolesWithCategories = rolesWithCategories.filter(role => {
          if (role.role) {
            return role.role.toLowerCase().match(this.filterRolesPhrase.toLowerCase());
          }
        });
      }

      if (filterCategory !== '') {
        rolesWithCategories = rolesWithCategories.filter(role => {
          if (role.category && filterCategory !== allRolesFilter && filterCategory !== noCategoryFilter) {
            return role.category.toLowerCase().match(filterCategory.toLowerCase());
          } else if (filterCategory === allRolesFilter) {
            return role;
          } else if (filterCategory === noCategoryFilter && !role.category) {
            return role;
          }
        });
      }

      return rolesWithCategories;
    }
  }
}
</script>
